import { Backdrop, Box, Button, Fade, Slide, Typography } from "@mui/material";
import React from "react";

const SkillsGroup = (props) => {
    const [open, setOpen] = React.useState(props.open);

    const handleOpen = () => {
        setOpen(!open)
    };

    return (
        <Box padding={2}>
            <Fade in={props.fade} style={{ transitionDelay: props.fade ? props.fadeDelay : '0ms' }}>
                {/*<img src={props.image} height={props.imageHeight} width={props.imageWidth} className="experience clickable" onClick={event => handleOpen()} />*/}
                <img src={`data:image/png;base64,${props.image}`} height={props.imageHeight} width={props.imageWidth} className="experience clickable" onClick={event => handleOpen()} />
            </Fade>
            <Slide timeout={props.slideDelay} direction={props.slideDirection} in={props.slide} mountOnEnter unmountOnExit>
                <Box>
                    <Backdrop
                        style={{ color: "#FFFFFF", backgroundColor: props.bgColor, opacity: .8, zIndex: 1 }}
                        open={open}
                        onClick={event => handleOpen()}>
                        <Box bgcolor={props.bgColor} width={"50%"}>
                            <Typography variant="h4" textAlign={"left"}>{props.skill}</Typography>
                            <Typography>
                                {props.text}
                            </Typography>
                        </Box>
                    </Backdrop>
                </Box>
            </Slide>
        </Box>
    )
};

export default SkillsGroup;
